<template>
  <div class="md-layout text-center">
    <div class="md-layout-item">
      <h3>Sorry. You don't have permission to view this resource.</h3>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
<style></style>
